
import printJS from 'print-js'
export const printContent = (id) => {
  printJS({
    printable: id,
    type: 'html',
    targetStyles: ['*'],  // 继承所有样式
    scanStyles: true      // 避免重复加载CSS
  })
}